export const orderTypeChoices = [
  {
    label: "ZOR (Standard Order)",
    value: "ZOR"
  },
  {
    label: "ZFC1",
    value: "ZFC1"
  },
  {
    label: "ZFC2",
    value: "ZFC2"
  }
];
